import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UrlModal } from '../shared/url.model';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MrService {

  constructor( private httpClient: HttpClient ,private router:Router) { }

  signupMr(
    data:any,
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/mr/reg',
      data,
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }

  loginMr(
    data:any,
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/mr/login',
      data,
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }

  bookAppt(
    data:any,
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/mr/newappointmentmr',
      data,        
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }
      
  onLogout() {
    localStorage.removeItem('myData');
    localStorage.clear();
    this.router.navigate(['/Market']);
  }

  getHos(
    page:any,limit:any,city:any
  ) {
    return this.httpClient.get(
      UrlModal._URL + `/hos/gethospitals?page=${page}&limit=${limit}&city=${city}`,
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }


  getmrappontment(
    id
  ) {
    return this.httpClient.get(
      UrlModal._URL + '/mr/appointmentmr/'+id,
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }



   getHosdoc(
    page:any,limit:any,id
  ) {
    return this.httpClient.post(
      UrlModal._URL + `/hos/gethospitaldoc?page=${page}&limit=${limit}` ,
      {id:id},
      {
        headers: new HttpHeaders({
        }),
      }
    );
  }
  
  
}